import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Stack = styled.div`
  display: grid;
  gap: 72px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 440px), 1fr));
  gap: clamp(36px, 5vw, 88px);
  align-items: center;
`;

export const TextColumn = styled.div<{ order?: number }>`
  order: ${props => props.order ?? 0};
`;

export const ImageColumn = styled.div<{ order?: number }>`
  order: ${props => props.order ?? 0};
  display: grid;
  place-items: center;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const Eyebrow = styled.div`
  font-family: ${typography.monoFontFamily};
  font-size: 12px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${colors.primary};
`;

export const Heading = styled.h3`
  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: clamp(26px, 3vw, 36px);
  line-height: 1.15;
  margin: 14px 0 22px;
  text-wrap: pretty;
  color: ${colors.textPrimary};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 14px;
  font-size: 16px;
  line-height: 1.55;
  color: ${colors.textSecondary};
`;

export const ListItem = styled.li`
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 12px;

  span:first-child {
    color: ${colors.primary};
  }
`;

export const PhoneMockup = styled.div`
  width: clamp(240px, 22vw, 330px);
  max-width: 100%;
  border-radius: 44px;
  border: 1px solid ${colors.borderAccent};
  background-color: ${colors.surface};
  overflow: hidden;
  box-shadow: 0 34px 70px rgba(0, 0, 0, 0.45);

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const IntroBlock = styled.div`
  max-width: 720px;
`;

export const WideRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 440px), 1fr));
  gap: clamp(36px, 4vw, 72px);
  align-items: start;
`;

export const DashboardMockup = styled.div`
  width: 100%;
  border-radius: 32px;
  border: 1px solid ${colors.border};
  background-color: ${colors.surface};
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: 700px) {
    display: none;
  }
`;

export const Footnote = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${colors.textFaintest};
  font-style: italic;
`;
